import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import IMAGE from 'images/cashout-reject.png';
import Spacer from 'Pages/Home/Components/Atoms/Spacer/Spacer';
import Style from './SpaceFull.module.scss';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { Button } from 'antd';
import { useHistory } from 'react-router';

interface ISpaceFullProps {
  isOpen: boolean;
  onClose: () => void;
}

const SpaceFull: React.FC<ISpaceFullProps> = (props) => {
  const history = useHistory();
  const { isOpen, onClose } = props;

  return (
    <Modal
      modalClassName="kick-notification-wrapper"
      isOpen={isOpen}
      className="kick-modal modal-upload-image-sell"
    >
      <ModalBody>
        <div className={Style['close']}>
          <AiOutlineCloseCircle className={Style['icon']} onClick={onClose} />
        </div>
        <img src={IMAGE} className={Style['image']} />
        <p style={{ textAlign: 'center', margin: 0 }}>
          <span className={Style['title']}>Warehouse Space is Full</span>
          <Spacer height={8} />
          <span className={Style['description']}>
            Sorry, warehouse space is full.
            <br />
            You can listing your product as Standard Listing
          </span>
        </p>
        <Button
          className={Style['button']}
          block
          onClick={() => {
            history.push({ pathname: `/sell-request` });
          }}
        >
          Continue to Standard Listing
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default SpaceFull;
